import api from '../config/api';

const seasonService = {
  async getAll() {
    const response = await api.get('/api/seasons');
    return response.data;
  },
};

export default seasonService;
